
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[serviceSlug]/[locationSlug]",
      function () {
        return require("private-next-pages/[serviceSlug]/[locationSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[serviceSlug]/[locationSlug]"])
      });
    }
  